// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file auth/auth_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import { file_common_common_model } from '../common/common_model_pb';
import type { Device_PlatformType } from '../device/device_model_pb';
import { file_device_device_model } from '../device/device_model_pb';
import { file_encryption_encryption_model } from '../encryption/encryption_model_pb';

/**
 * Describes the file auth/auth_model.proto.
 */
export const file_auth_auth_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChVhdXRoL2F1dGhfbW9kZWwucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IiQKEFN0aWNrZXJzVXBkYXRlVHMSEAoIdXBkYXRlVHMYASABKAMiKAoUVXNlclN0aWNrZXJzVXBkYXRlVHMSEAoIdXBkYXRlVHMYASABKAMiKAoTU3VwcG9ydGVkU0RLVmVyc2lvbhIRCglzdXBwb3J0ZWQYASABKAgiIAoNVmlkZW9BdXRvcGxheRIPCgdlbmFibGVkGAEgASgIIiUKEVJlYWN0aW9uc1VwZGF0ZVRzEhAKCHVwZGF0ZVRzGAEgASgDIiYKCkFkbWluVWlVcmwSGAoQYWRtaW5BdXRoVXJsQmFzZRgBIAEoCSJKCgpCYWNrZ3JvdW5kEgoKAmlkGAEgASgJEg0KBW9yZGVyGAIgASgFEgsKA3VybBgDIAEoCRIUCgxhdmVyYWdlQ29sb3IYBCABKAkiPgoLQmFja2dyb3VuZHMSLwoFaXRlbXMYASADKAsyIC5jb20uZ2VtLmJmZi5jb250cmFjdC5CYWNrZ3JvdW5kIvADChBDbGllbnRDb25maWdJdGVtEkoKFHVzZXJTdGlja2Vyc1VwZGF0ZVRzGAEgASgLMiouY29tLmdlbS5iZmYuY29udHJhY3QuVXNlclN0aWNrZXJzVXBkYXRlVHNIABJIChNzdXBwb3J0ZWRTREtWZXJzaW9uGAIgASgLMikuY29tLmdlbS5iZmYuY29udHJhY3QuU3VwcG9ydGVkU0RLVmVyc2lvbkgAEjwKDXZpZGVvQXV0b3BsYXkYAyABKAsyIy5jb20uZ2VtLmJmZi5jb250cmFjdC5WaWRlb0F1dG9wbGF5SAASRAoRcmVhY3Rpb25zVXBkYXRlVHMYBCABKAsyJy5jb20uZ2VtLmJmZi5jb250cmFjdC5SZWFjdGlvbnNVcGRhdGVUc0gAEkIKEHN0aWNrZXJzVXBkYXRlVHMYBSABKAsyJi5jb20uZ2VtLmJmZi5jb250cmFjdC5TdGlja2Vyc1VwZGF0ZVRzSAASPAoQYWRtaW5BdXRoVXJsQmFzZRgGIAEoCzIgLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkFkbWluVWlVcmxIABI4CgtiYWNrZ3JvdW5kcxgHIAEoCzIhLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkJhY2tncm91bmRzSABCBgoEdHlwZSJFCgxDbGllbnRDb25maWcSNQoFaXRlbXMYASADKAsyJi5jb20uZ2VtLmJmZi5jb250cmFjdC5DbGllbnRDb25maWdJdGVtIqcBCg9Mb2dpbkRldmljZUluZm8SEAoIZGV2aWNlSWQYASABKAkSOwoIcGxhdGZvcm0YAiABKA4yKS5jb20uZ2VtLmJmZi5jb250cmFjdC5EZXZpY2UuUGxhdGZvcm1UeXBlEg4KBmRldmljZRgDIAEoCRIOCgZvc05hbWUYBCABKAkSEQoJb3NWZXJzaW9uGAUgASgJEhIKCmFwcFZlcnNpb24YBiABKAlCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_common_common_model, file_encryption_encryption_model, file_device_device_model]
  );

/**
 * STICKERS_UPDATE_TS = "stickers.last.update.timestamp"
 *
 * @generated from message com.gem.bff.contract.StickersUpdateTs
 */
export type StickersUpdateTs = Message<'com.gem.bff.contract.StickersUpdateTs'> & {
  /**
   * @generated from field: int64 updateTs = 1;
   */
  updateTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.StickersUpdateTs.
 * Use `create(StickersUpdateTsSchema)` to create a new message.
 */
export const StickersUpdateTsSchema: GenMessage<StickersUpdateTs> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 0);

/**
 * KEY_USER_STICKERS_UPDATE_TS = "user.stickers.last.update.timestamp"
 *
 * @generated from message com.gem.bff.contract.UserStickersUpdateTs
 */
export type UserStickersUpdateTs = Message<'com.gem.bff.contract.UserStickersUpdateTs'> & {
  /**
   * @generated from field: int64 updateTs = 1;
   */
  updateTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.UserStickersUpdateTs.
 * Use `create(UserStickersUpdateTsSchema)` to create a new message.
 */
export const UserStickersUpdateTsSchema: GenMessage<UserStickersUpdateTs> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 1);

/**
 * KEY_IS_SUPPORTED_SDK = "SupportedVersion"
 *
 * @generated from message com.gem.bff.contract.SupportedSDKVersion
 */
export type SupportedSDKVersion = Message<'com.gem.bff.contract.SupportedSDKVersion'> & {
  /**
   * @generated from field: bool supported = 1;
   */
  supported: boolean;
};

/**
 * Describes the message com.gem.bff.contract.SupportedSDKVersion.
 * Use `create(SupportedSDKVersionSchema)` to create a new message.
 */
export const SupportedSDKVersionSchema: GenMessage<SupportedSDKVersion> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 2);

/**
 * KEY_FEATURE_VIDEO_AUTOPLAY = "feature.video.autoplay"
 *
 * @generated from message com.gem.bff.contract.VideoAutoplay
 */
export type VideoAutoplay = Message<'com.gem.bff.contract.VideoAutoplay'> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message com.gem.bff.contract.VideoAutoplay.
 * Use `create(VideoAutoplaySchema)` to create a new message.
 */
export const VideoAutoplaySchema: GenMessage<VideoAutoplay> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 3);

/**
 * KEY_REACTIONS_UPDATE_TS = "reactions.last.update.timestamp"
 *
 * @generated from message com.gem.bff.contract.ReactionsUpdateTs
 */
export type ReactionsUpdateTs = Message<'com.gem.bff.contract.ReactionsUpdateTs'> & {
  /**
   * @generated from field: int64 updateTs = 1;
   */
  updateTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ReactionsUpdateTs.
 * Use `create(ReactionsUpdateTsSchema)` to create a new message.
 */
export const ReactionsUpdateTsSchema: GenMessage<ReactionsUpdateTs> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 4);

/**
 * @generated from message com.gem.bff.contract.AdminUiUrl
 */
export type AdminUiUrl = Message<'com.gem.bff.contract.AdminUiUrl'> & {
  /**
   * @generated from field: string adminAuthUrlBase = 1;
   */
  adminAuthUrlBase: string;
};

/**
 * Describes the message com.gem.bff.contract.AdminUiUrl.
 * Use `create(AdminUiUrlSchema)` to create a new message.
 */
export const AdminUiUrlSchema: GenMessage<AdminUiUrl> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 5);

/**
 * @generated from message com.gem.bff.contract.Background
 */
export type Background = Message<'com.gem.bff.contract.Background'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 order = 2;
   */
  order: number;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: string averageColor = 4;
   */
  averageColor: string;
};

/**
 * Describes the message com.gem.bff.contract.Background.
 * Use `create(BackgroundSchema)` to create a new message.
 */
export const BackgroundSchema: GenMessage<Background> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 6);

/**
 * @generated from message com.gem.bff.contract.Backgrounds
 */
export type Backgrounds = Message<'com.gem.bff.contract.Backgrounds'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.Background items = 1;
   */
  items: Background[];
};

/**
 * Describes the message com.gem.bff.contract.Backgrounds.
 * Use `create(BackgroundsSchema)` to create a new message.
 */
export const BackgroundsSchema: GenMessage<Backgrounds> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 7);

/**
 * @generated from message com.gem.bff.contract.ClientConfigItem
 */
export type ClientConfigItem = Message<'com.gem.bff.contract.ClientConfigItem'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ClientConfigItem.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserStickersUpdateTs userStickersUpdateTs = 1;
         */
        value: UserStickersUpdateTs;
        case: 'userStickersUpdateTs';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SupportedSDKVersion supportedSDKVersion = 2;
         */
        value: SupportedSDKVersion;
        case: 'supportedSDKVersion';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.VideoAutoplay videoAutoplay = 3;
         */
        value: VideoAutoplay;
        case: 'videoAutoplay';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ReactionsUpdateTs reactionsUpdateTs = 4;
         */
        value: ReactionsUpdateTs;
        case: 'reactionsUpdateTs';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.StickersUpdateTs stickersUpdateTs = 5;
         */
        value: StickersUpdateTs;
        case: 'stickersUpdateTs';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AdminUiUrl adminAuthUrlBase = 6;
         */
        value: AdminUiUrl;
        case: 'adminAuthUrlBase';
      }
    | {
        /**
         * /...
         *
         * @generated from field: com.gem.bff.contract.Backgrounds backgrounds = 7;
         */
        value: Backgrounds;
        case: 'backgrounds';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ClientConfigItem.
 * Use `create(ClientConfigItemSchema)` to create a new message.
 */
export const ClientConfigItemSchema: GenMessage<ClientConfigItem> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 8);

/**
 * @generated from message com.gem.bff.contract.ClientConfig
 */
export type ClientConfig = Message<'com.gem.bff.contract.ClientConfig'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.ClientConfigItem items = 1;
   */
  items: ClientConfigItem[];
};

/**
 * Describes the message com.gem.bff.contract.ClientConfig.
 * Use `create(ClientConfigSchema)` to create a new message.
 */
export const ClientConfigSchema: GenMessage<ClientConfig> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 9);

/**
 * @generated from message com.gem.bff.contract.LoginDeviceInfo
 */
export type LoginDeviceInfo = Message<'com.gem.bff.contract.LoginDeviceInfo'> & {
  /**
   * @generated from field: string deviceId = 1;
   */
  deviceId: string;

  /**
   * @generated from field: com.gem.bff.contract.Device.PlatformType platform = 2;
   */
  platform: Device_PlatformType;

  /**
   * @generated from field: string device = 3;
   */
  device: string;

  /**
   * @generated from field: string osName = 4;
   */
  osName: string;

  /**
   * @generated from field: string osVersion = 5;
   */
  osVersion: string;

  /**
   * @generated from field: string appVersion = 6;
   */
  appVersion: string;
};

/**
 * Describes the message com.gem.bff.contract.LoginDeviceInfo.
 * Use `create(LoginDeviceInfoSchema)` to create a new message.
 */
export const LoginDeviceInfoSchema: GenMessage<LoginDeviceInfo> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_model, 10);
